import React from 'react';
import useMobile from 'utils/useMobile';

import HeroContainerMobile from 'components/HeroContainer/mobile';
import { Link as RouterLink } from 'react-router-dom';
import TypographyHeaderSub from '../TypographyHeaderSub';
import { Typography } from '@material-ui/core';
import HeaderButton from '../HeaderButton';
import HeroContainer from 'components/HeroContainer/desktop';
import { ROUTE_SIGN_UP } from 'routes/routes';

const HeroContentLanding = () => {
  const isMobile = useMobile();
  const Container = isMobile ? HeroContainerMobile : HeroContainer;
  const headerSize = isMobile ? 'h4' : 'h2';
  return (
    <Container>
      {!isMobile && <TypographyHeaderSub gutterBottom>START YOUR TRANSFORMATION TODAY!</TypographyHeaderSub>}
      <Typography color="textPrimary" variant={headerSize}>
        IT'S TIME TO PUT
      </Typography>
      <Typography color="textPrimary" variant={headerSize}>
        YOUR BODYF1RST!
      </Typography>

      <HeaderButton size="large" component={RouterLink} to={ROUTE_SIGN_UP}>
        sign up now
      </HeaderButton>
    </Container>
  );
};

export default HeroContentLanding;
